<ion-tab-bar>
    <ng-content></ng-content>
</ion-tab-bar>
